<template>
<div class="m4u_tertiary">
  <div class='m4u_text--text ml-3'>
    <h2 >QuickConnect</h2>
<h4>Learn More About Your Circle</h4>
     </div>

    <div >
        <v-expansion-panels focusable class="teal--text">
    <v-expansion-panel
      v-for="question in questions"
      :key="question.ViewPointID"
    >
            
      <v-expansion-panel-header class="teal--text" @click="getAnswers(question.ViewPointID)">
        {{question.ViewPointDate}}, {{question.ViewPointQ}} 
      </v-expansion-panel-header>
      <v-expansion-panel-content>

        <!--- STARTING DIALOG TO EDIT USER'S ANSWER FOR A PARTICULAR QUESTION --->

  <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small 
          icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          @click="getMyAnswer(question.ViewPointID)"
        >
          <v-icon class="m4u_text--text">mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline m4u_text--text">Edit Your Answer</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>

              <v-col cols="12">
                <v-text-field
                  label="Your Answer"
                  v-model= "myanswer"
                  color="m4u_text"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="saveAnswer(question.ViewPointID)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


        <!--- ENDING DIALOG TO EDIT USER'S ANSWER --->
          <div v-for="answer in answers" :key="answer.VPAnswerID" class="m4u_text--text">
          <strong >{{answer.UserDisplayName}}: </strong> {{answer.VPAnswer}} <br/><br/>
          </div>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    </div>

</div>
</template>
<script>

import EventService from '@/services/EventService.js'; 

export default {

  data() {
    return {
        questions: [],
        vpID: '',
        answers: [],
        headers: [
        {
          text: 'Circle Member',
          align: 'start',
          sortable: false,
          value: 'UserDisplayName',
        },
        { text: 'Answer', value: 'VPAnswer' },
      ],
      dialog: false,
      myanswer: ''

       }
    },
  
  
mounted() {

    this.getQuickConnectQuestions();
  },


computed: {
  user(){
    return this.$store.state.user
  }
},
  loginState(){
    return this.$store.state.loginState
  },

  methods: {
    async getQuickConnectQuestions() {
      // NEW - Use the eventService to call the getEvents() method
      await EventService.getQuickConnectQuestions()
      .then(
        (questions => {
          this.$set(this, "questions", questions);
        }).bind(this)

      );
    },

    async getAnswers(ViewPointID) {
      // NEW - Use the eventService to call the getEvents() method
      await EventService.getAnswers(this.user.UserID, ViewPointID)
      .then(
        (answers => {
          this.$set(this, "answers", answers);
        }).bind(this)

      );
    },

    async getMyAnswer(viewPointID) {
      await EventService.getMyAnswer(this.user.UserID, viewPointID)
      .then(
        (async myanswer => {
          this.$set(this, "myanswer", myanswer[0].VPAnswer);
        }).bind(this)

      )
  },

      async saveAnswer(viewPointID) {
      this.dialog = false
      await EventService.saveMyAnswer(this.user.UserID, viewPointID, this.myanswer)
      .then( async () => {
        this.myanswer = '';
        this.getAnswers(viewPointID)
      }

      )
    }

}
}


</script>
<style lang="scss" scoped>



</style>